import useTranslation from "../../hooks/useTranslation";

import TEXT from "../../configs/text";

import ICONS from "../../configs/icons";

import styles from "./index.module.scss";

export default function PaymentError() {
    const translation = useTranslation();

    const handleText = (text) => {
        if (translation?.pages?.payment_error?.[text]) {
            return translation?.pages?.payment_error?.[text];
        }

        return TEXT?.pages?.payment_error?.[text];
    };

    return (
        <div className={styles['payment-error-page']}>
            <div className={styles['message-container']}>
                {ICONS.CLOSE_ICON}
                <h1 className={styles['title']}>{handleText('page_name')}</h1>
                <span className={styles['message']}>{handleText('message')}</span>
            </div>
        </div>
    )
}
